/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Daily_Picks_ContentInputs */

const en_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ Daily Picks includes items from past events and challenge rewards. More items are added from time to time.

・ Items refresh daily at 00:00 (UTC+0). You can also spend in-game currency to refresh them manually. The scheduled daily refresh will still happen as usual.

・ Both manual and daily refreshes only show items you haven’t unlocked. Items currently on display may appear again.`)
};

const ar_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ تتضمن مختارات اليوم منتجات من فعاليات سابقة ومكافآت التحديات. تُضاف منتجات أخرى من وقت لآخر.

・ تُحدَّث المنتجات يوميًا عند 00:00 (UTC+0). يمكنك أيضًا إنفاق عملة داخل اللعبة لتحديثها يدويًا. وسيظل التحديث اليومي المجدول يجري في موعده المعتاد.

・ لا تُظهر التحديثات اليدوية واليومية إلا المنتجات التي لم تفتحها بعد. وقد تظهر المنتجات المعروضة حاليًا مرة أخرى.`)
};

const de_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ Die Rubrik „Tägliche Auswahl“ enthält Artikel aus früheren Events und Belohnungen aus Herausforderungen. Von Zeit zu Zeit kommen weitere Artikel hinzu.

・ Die Artikel werden täglich um 00:00 (UTC+0) aktualisiert. Du kannst sie auch mit Spielwährung manuell aktualisieren. Die geplante tägliche Aktualisierung findet trotzdem wie gewohnt statt.

・ Bei manuellen und täglichen Aktualisierungen erscheinen nur Artikel, die du noch nicht freigeschaltet hast. Aktuell angezeigte Artikel können erneut erscheinen.`)
};

const es_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ La Selección diaria incluye artículos de eventos anteriores y recompensas de desafíos. Se añaden más artículos de vez en cuando.

・ Los artículos se actualizan cada día a las 00:00 (UTC+0). También puedes gastar divisas del juego para actualizarlos manualmente. La actualización diaria programada seguirá realizándose como de costumbre.

・ Tanto las actualizaciones manuales como las diarias solo muestran artículos que aún no has desbloqueado. Los artículos que se muestran actualmente pueden volver a aparecer.`)
};

const fr_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ La Sélection du jour propose des articles d’événements passés et des récompenses de défis. D’autres articles sont ajoutés de temps en temps.

・ Les articles sont actualisés chaque jour à 00:00 (UTC+0). Vous pouvez aussi dépenser de la monnaie du jeu pour les actualiser manuellement. L’actualisation quotidienne prévue aura toujours lieu comme d’habitude.

・ Les actualisations manuelles et quotidiennes n’affichent que des articles que vous n’avez pas encore débloqués. Les articles actuellement affichés peuvent réapparaître.`)
};

const it_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ La sezione «Scelte del giorno» include articoli di eventi passati e ricompense delle sfide. Altri articoli vengono aggiunti di tanto in tanto.

・ Gli articoli si aggiornano ogni giorno alle 00:00 (UTC+0). Puoi anche spendere valuta di gioco per aggiornarli manualmente. L’aggiornamento giornaliero programmato avverrà comunque come di consueto.

・ Gli aggiornamenti manuali e giornalieri mostrano solo articoli che non hai ancora sbloccato. Gli articoli attualmente visibili potrebbero apparire di nuovo.`)
};

const ja_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ デイリーピックには過去のイベントアイテムやチャレンジ報酬が登場します。アイテムは不定期に追加されます。

・ 商品は毎日 00:00（UTC+0）に更新されます。ゲーム内通貨を使って手動で更新することもできます。手動で更新しても、毎日の定時更新は通常どおり行われます。

・ 手動更新でも定時更新でも、まだアンロックしていない商品だけが表示されます。現在表示されている商品が再び登場することもあります。`)
};

const ko_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ 오늘의 추천에는 지난 이벤트 상품과 챌린지 보상이 포함되며, 상품은 비정기적으로 추가됩니다.

・ 상품은 매일 00:00 (UTC+0)에 새로고침됩니다. 게임 내 재화를 사용해 직접 새로고침할 수도 있습니다. 직접 새로고침해도 정해진 시간의 일일 새로고침은 그대로 진행됩니다.

・ 직접 새로고침하거나 매일 정해진 시간에 새로고침할 때 모두 아직 잠금 해제하지 않은 상품만 표시됩니다. 현재 표시된 상품이 다시 나올 수도 있습니다.`)
};

const pt_br_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ A seção Escolhas do dia inclui itens de eventos anteriores e recompensas de desafios. Mais itens são adicionados de tempos em tempos.

・ Os itens são atualizados diariamente às 00:00 (UTC+0). Você também pode gastar moeda do jogo para atualizá-los manualmente. A atualização diária programada continuará acontecendo normalmente.

・ Tanto as atualizações manuais quanto as diárias mostram apenas itens que você ainda não desbloqueou. Os itens exibidos no momento podem aparecer novamente.`)
};

const ru_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ Раздел «Ежедневная подборка» включает товары из прошлых событий и награды за задания. Время от времени добавляются новые товары.

・ Предметы обновляются ежедневно в 00:00 (UTC+0). Вы также можете потратить игровую валюту, чтобы обновить их вручную. Плановое ежедневное обновление всё равно произойдёт в обычное время.

・ При ручном и ежедневном обновлении появляются только товары, которые вы ещё не разблокировали. Предметы, показанные сейчас, могут появиться снова.`)
};

const th_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ รายการแนะนำประจำวันมีสินค้าจากกิจกรรมที่ผ่านมาและรางวัลจากความท้าทาย โดยจะมีสินค้าเพิ่มเข้ามาเป็นครั้งคราว

・ สินค้าจะรีเฟรชทุกวันเวลา 00:00 (UTC+0) คุณยังสามารถใช้สกุลเงินในเกมเพื่อรีเฟรชด้วยตัวเองได้ โดยการรีเฟรชประจำวันจะยังคงเกิดขึ้นตามเวลาเดิม

・ ไม่ว่าจะรีเฟรชด้วยตัวเองหรือตามเวลาประจำวัน จะแสดงเฉพาะสินค้าที่ยังไม่ได้ปลดล็อกเท่านั้น สินค้าที่แสดงอยู่ตอนนี้อาจปรากฏขึ้นอีกครั้งได้`)
};

const tr_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ Günün Seçimleri, geçmiş etkinliklerin ürünlerini ve mücadele ödüllerini içerir. Zaman zaman yeni ürünler eklenir.

・ Ürünler her gün 00:00 (UTC+0) saatinde yenilenir. Oyun içi para birimi harcayarak ürünleri kendin de yenileyebilirsin. Planlanan günlük yenileme her zamanki saatinde yine gerçekleşir.

・ Hem manuel hem de günlük yenilemelerde yalnızca henüz kilidini açmadığın ürünler görünür. Şu anda gösterilen ürünler tekrar karşına çıkabilir.`)
};

const zh_cn_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ 每日精选商品包含过往活动商品及挑战奖励，并会不定期新增。

・ 每日固定于 00:00（UTC+0）刷新，也可花费货币手动刷新商品。原定的每日刷新仍会照常进行。

・ 无论是手动刷新还是每日定时刷新，都只会出现尚未解锁的商品，但可能出现与当前重复的商品。`)
};

const zh_tw_dialog_daily_picks_content = /** @type {(inputs: Dialog_Daily_Picks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`・ 每日精選商品包含過往活動商品及挑戰獎勵，並會不定期新增。

・ 每日固定於 00:00（UTC+0）刷新，可花費貨幣主動刷新商品，但原定的每日刷新仍會照常進行。

・ 無論是手動或是固定每日刷新，都只會出現尚未解鎖的商品，且有可能會出現與當前重複的商品。`)
};

/**
* | output |
* | --- |
* | "・ Daily Picks includes items from past events and challenge rewards. More items are added from time to time. ・ Items refresh daily at 00:00 (UTC+0). You can ..." |
*
* @param {Dialog_Daily_Picks_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_daily_picks_content = /** @type {((inputs?: Dialog_Daily_Picks_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Daily_Picks_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_daily_picks_content(inputs)
	if (locale === "ar") return ar_dialog_daily_picks_content(inputs)
	if (locale === "de") return de_dialog_daily_picks_content(inputs)
	if (locale === "es") return es_dialog_daily_picks_content(inputs)
	if (locale === "fr") return fr_dialog_daily_picks_content(inputs)
	if (locale === "it") return it_dialog_daily_picks_content(inputs)
	if (locale === "ja") return ja_dialog_daily_picks_content(inputs)
	if (locale === "ko") return ko_dialog_daily_picks_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_daily_picks_content(inputs)
	if (locale === "ru") return ru_dialog_daily_picks_content(inputs)
	if (locale === "th") return th_dialog_daily_picks_content(inputs)
	if (locale === "tr") return tr_dialog_daily_picks_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_daily_picks_content(inputs)
	return zh_tw_dialog_daily_picks_content(inputs)
});